(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offigo-add-to-cart"] && !Shopify.designMode) return;
  try {
    
class StickyProductCart extends HTMLElement {
  #observer;
  #form;
  #primaryButton;
  #drawerTimeout;

  connectedCallback() {
    const productId = this.dataset.productId;
    this.#form = document.querySelector(`main product-form-component[data-product-id="${productId}"]`);
    this.#primaryButton = this.#form?.querySelector('[ref="addToCartButton"]');

    if (!this.#form || !this.#primaryButton) {
      this.remove();
      return;
    }

    this.#syncButtonState();
    this.#syncAccessories();

    this.#observer = new IntersectionObserver(
      ([entry]) => {
        this.dataset.visible = String(!entry.isIntersecting);
      },
      { threshold: 0 }
    );
    this.#observer.observe(this.#primaryButton);

    this.querySelector('[ref="addButton"]')?.addEventListener('click', this.#submit);
    this.#form.addEventListener('change', this.#syncAccessories);
    document.addEventListener('variant:update', this.#syncVariant);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.querySelector('[ref="addButton"]')?.removeEventListener('click', this.#submit);
    this.#form?.removeEventListener('change', this.#syncAccessories);
    document.removeEventListener('variant:update', this.#syncVariant);
    document.removeEventListener('cart:update', this.#openCartDrawer);
    clearTimeout(this.#drawerTimeout);
  }

  #syncButtonState = () => {
    const addButton = this.querySelector('[ref="addButton"]');
    if (addButton instanceof HTMLButtonElement) addButton.disabled = this.#primaryButton?.disabled ?? true;
  };

  #syncVariant = (event) => {
    if (event.detail?.data?.productId !== this.dataset.productId) return;

    const variant = event.detail.resource;
    const price = event.detail?.data?.html?.querySelector('product-price [ref="priceContainer"]')?.textContent?.trim();
    const label = this.querySelector('[ref="variantLabel"]');
    const priceElement = this.querySelector('[ref="variantPrice"]');

    if (variant && this.dataset.hasOnlyDefaultVariant !== 'true' && label) label.textContent = variant.title;
    if (price && priceElement) priceElement.textContent = price;
    this.#syncButtonState();
  };

  #syncAccessories = () => {
    const container = this.querySelector('[ref="accessoryLines"]');
    if (!(container instanceof HTMLElement) || !this.#form) return;

    const accessories = Array.from(this.#form.querySelectorAll('[data-sticky-cart-accessory]')).filter((control) => {
      if (control instanceof HTMLInputElement) return control.checked;
      return control instanceof HTMLSelectElement && control.value !== '';
    });

    container.replaceChildren();
    accessories.forEach((control) => {
      const line = document.createElement('div');
      const label = document.createElement('span');
      const price = document.createElement('span');
      line.className = 'sticky-product-cart__accessory-line';
      label.textContent = control.dataset.stickyCartAccessoryLabel || control.getAttribute('aria-label') || control.name;
      price.textContent = control.dataset.stickyCartAccessoryPrice || '';
      line.append(label, price);
      container.append(line);
    });
    container.hidden = accessories.length === 0;
  };

  #submit = () => {
    if (this.#primaryButton?.disabled) return;

    document.addEventListener('cart:update', this.#openCartDrawer);
    clearTimeout(this.#drawerTimeout);
    this.#drawerTimeout = window.setTimeout(() => {
      document.removeEventListener('cart:update', this.#openCartDrawer);
    }, 8000);
    this.#primaryButton.click();
  };

  #openCartDrawer = (event) => {
    if (event.detail?.data?.source !== 'product-form-component' || event.detail?.data?.didError) return;

    document.querySelector('cart-drawer-component')?.open();
    document.removeEventListener('cart:update', this.#openCartDrawer);
    clearTimeout(this.#drawerTimeout);
  };
}

if (!customElements.get('sticky-product-cart')) {
  customElements.define('sticky-product-cart', StickyProductCart);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offigo-creator-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('offigo-creator-videos')) {
    class OffiGoCreatorVideos extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.rail = this.querySelector('[data-ocv-rail]');
        this.dialog = this.querySelector('[data-ocv-dialog]');
        this.previous = this.querySelector('[data-ocv-prev]');
        this.next = this.querySelector('[data-ocv-next]');
        if (!this.rail || !this.dialog) return;
        this.cards = Array.from(this.rail.children);
        this.querySelectorAll('[data-ocv-open], [data-ocv-expand]').forEach(button => { button.hidden = false; });
        this.cards.forEach(card => {
          card.addEventListener('pointerenter', event => {
            if (event.pointerType === 'mouse' && matchMedia('(hover: hover) and (pointer: fine)').matches) this.activate(card);
          }, options);
          card.addEventListener('focusin', () => this.activate(card), options);
        });
        this.setAttribute('data-ocv-ready', '');
        this.activate(this.cards[0], false);
        this.previous.hidden = false;
        this.next.hidden = false;
        this.addEventListener('click', event => {
          const opener = event.target.closest('[data-ocv-open]');
          if (opener) this.open(opener);
          const expander = event.target.closest('[data-ocv-expand]');
          if (expander) this.activate(expander.closest('[data-ocv-card]'));
          if (event.target.closest('[data-ocv-close]')) this.dialog.close();
          if (event.target.closest('[data-ocv-prev]')) this.move(-1);
          if (event.target.closest('[data-ocv-next]')) this.move(1);
        }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => { if (!this.dialog.open) this.release(); }, options);
        this.rail.addEventListener('scroll', () => this.updateNavigation(), { ...options, passive: true });
        this.rail.addEventListener('transitionend', event => {
          if (event.propertyName === 'flex-basis' && event.target === this.activeCard) {
            this.ensureVisible(this.activeCard);
            this.updateNavigation();
          }
        }, options);
        this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
        this.resizeObserver.observe(this.rail);
        document.addEventListener('shopify:block:select', event => {
          if (event.detail.sectionId !== this.dataset.sectionId) return;
          const card = Array.from(this.rail.children).find(item => item.dataset.ocvCard === event.detail.blockId);
          if (card) this.activate(card);
        }, options);
        this.updateNavigation();
      }

      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.release();
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.controller = null;
      }

      move(direction) {
        const index = this.cards.indexOf(this.activeCard);
        const target = this.cards[Math.max(0, Math.min(this.cards.length - 1, index + direction))];
        this.activate(target);
      }

      activate(card, reveal = true) {
        if (!card || this.activeCard === card) return;
        this.activeCard = card;
        this.cards.forEach(item => {
          const active = item === card;
          item.classList.toggle('is-active', active);
          const body = item.querySelector('.ocv__body');
          body.inert = !active;
          body.setAttribute('aria-hidden', String(!active));
          item.querySelector('[data-ocv-expand]')?.setAttribute('aria-expanded', String(active));
        });
        this.updateNavigation();
        if (reveal) this.ensureVisible(card);
      }

      ensureVisible(card) {
        if (!card?.isConnected) return;
        const railBounds = this.rail.getBoundingClientRect();
        const cardBounds = card.getBoundingClientRect();
        let delta = 0;
        if (cardBounds.left < railBounds.left) delta = cardBounds.left - railBounds.left;
        else if (cardBounds.right > railBounds.right) delta = cardBounds.right - railBounds.right;
        if (Math.abs(delta) > 2) this.rail.scrollBy({ left: delta, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }

      updateNavigation() {
        const index = this.cards.indexOf(this.activeCard);
        this.previous.disabled = index <= 0;
        this.next.disabled = index >= this.cards.length - 1;
        this.previous.hidden = this.cards.length <= 1;
        this.next.hidden = this.cards.length <= 1;
      }

      open(opener) {
        this.activate(opener.closest('[data-ocv-card]'));
        const template = document.getElementById(opener.dataset.ocvOpen);
        if (!template || this.dialog.open) return;
        document.querySelectorAll('offigo-creator-videos dialog[open]').forEach(dialog => {
          dialog.close();
          dialog.closest('offigo-creator-videos')?.release();
        });
        this.opener = opener;
        this.dialog.replaceChildren(template.content.cloneNode(true));
        const title = this.dialog.querySelector('.ocv__dialog-title');
        this.dialog.setAttribute('aria-labelledby', title.id);
        this.dialog.showModal();
        this.savedOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.scrollLocked = true;
        const video = this.dialog.querySelector('video');
        video?.play()?.catch(() => {});
        this.dialog.querySelector('[data-ocv-close]')?.focus();
      }

      release() {
        this.dialog?.querySelectorAll('video').forEach(video => {
          video.pause();
          video.removeAttribute('src');
          video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
          video.load();
        });
        this.dialog?.replaceChildren();
        if (this.scrollLocked) {
          document.documentElement.style.overflow = this.savedOverflow;
          this.scrollLocked = false;
        }
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        this.opener = null;
      }
    }
    customElements.define('offigo-creator-videos', OffiGoCreatorVideos);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offigo-tabbed-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('offigo-tabbed-products')) {
    customElements.define('offigo-tabbed-products', class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.links = [...this.querySelectorAll('[data-offigo-tab-link]')];
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      activate = (index, focus = false) => {
        if (!this.tabs[index]) return;
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          this.panels[i].hidden = !active;
        });
        this.links.forEach((link) => {
          link.hidden = Number(link.dataset.offigoTabLink) !== index;
        });
        if (focus) this.tabs[index].focus();
      };

      onClick = (event) => {
        const tab = event.target.closest('[role="tab"]');
        const index = this.tabs.indexOf(tab);
        if (index >= 0) this.activate(index);
      };

      onKeydown = (event) => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.activate(next, true);
      };

      onBlockSelect = (event) => {
        const tab = event.target.closest('[role="tab"]');
        const index = this.tabs.indexOf(tab);
        if (index >= 0) this.activate(index);
      };
    });
  }

  } catch(e) { console.error(e); }
})();
})();
